import { IOAuthProvider } from './types';

/**
 * Central registry for all OAuth providers
 * Allows dynamic registration and retrieval of providers
 */
class OAuthProviderRegistry {
  private providers: Map<string, IOAuthProvider> = new Map();

  /**
   * Register a new OAuth provider
   */
  registerProvider(provider: IOAuthProvider): void {
    if (this.providers.has(provider.id)) {
      console.warn(`Provider ${provider.id} is already registered. Overwriting...`);
    }
    this.providers.set(provider.id, provider);
  }

  /**
   * Get a provider by ID
   */
  getProvider(id: string): IOAuthProvider | undefined {
    return this.providers.get(id);
  }

  /**
   * Get all registered providers
   */
  getAllProviders(): IOAuthProvider[] {
    return Array.from(this.providers.values());
  }

  /**
   * Check if a provider is registered
   */
  hasProvider(id: string): boolean {
    return this.providers.has(id);
  }

  /**
   * Get all provider IDs
   */
  getProviderIds(): string[] {
    return Array.from(this.providers.keys());
  }

  /**
   * Clear all registered providers (useful for testing)
   */
  clear(): void {
    this.providers.clear();
  }
}

// Singleton instance
export const providerRegistry = new OAuthProviderRegistry();
